module.exports = "\n<div id=\"rendered-document\" class=\"sheet letter\" >\n    <ng-template #dynamic></ng-template>\n</div>"